import { FC, useEffect } from 'react';

import { MasterAgreement } from '../../../store/_declarations/target';
import { legalNoteApi } from '../../../store/api/legalNote';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import Font from '../../atoms/Font';
import Icon from '../../atoms/Icon';
import Controllers from './Controllers';
import Services from './Services';
import {
  ContentWrapper,
  Divider,
  SelectedCardContainer,
  WrapperProduct
} from './styles';
import Title from './Title';
import Unselected from './Unselected';

export type ProductCardProps = {
  cardId: number | string;
  isLoading: boolean;
  item: MasterAgreement;
};

const ProductCard: FC<ProductCardProps> = ({ cardId, isLoading, item }) => {
  const { consumerPayload, selectedItem, widgetType } = useAppSelector(
    (state) => state.app
  );
  const { listByVehicle } = useAppSelector(
    (state) => state.financialCalculator
  );

  const { notes } = useAppSelector((state) => state.legalNote);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (item) {
      dispatch(
        legalNoteApi({
          legalNote: {
            brandText: consumerPayload?.vehicle?.presentation?.brandLabel || '',
            countryCode: consumerPayload?.context.countryCode || '',
            customerType: consumerPayload?.context.customer.clientType || '',
            fuelType: listByVehicle?.materialInfo?.zzJatoPowerTr || '',
            km: item.options.km.find((o) => o.isDefault)?.km || 0,
            languageCode:
              consumerPayload?.context.languageCode.toUpperCase() || '',
            masterAgreement: Number(item.masterAgreement),
            modelText: consumerPayload?.vehicle.presentation?.longLabel || '',
            month: item.options.month.find((o) => o.isDefault)?.month || 0,
            site_code: consumerPayload?.context.siteCode || ''
          }
        })
      );
    }
  }, [item]);

  return selectedItem === cardId ? (
    <WrapperProduct
      $selected={selectedItem === cardId}
      $type="1"
      $widgetType={widgetType}
      data-testid="wrapper_product"
    >
      {widgetType === 'modal' && <Title isLoading={isLoading} item={item} />}
      <ContentWrapper>
        <Controllers item={item} />
        <Services item={item} />
      </ContentWrapper>

      {widgetType === 'modal' && (
        <>
          <Divider />
          <Font
            customConfiguration={{ color: 'textBody' }}
            variant="bodySRegular"
          >
            {
              notes.find(
                (n: any) => String(n.id) === String(item.masterAgreement)
              )?.text
            }
          </Font>
          {selectedItem === cardId && (
            <SelectedCardContainer data-testid="icon_selected">
              <Icon iconColor="white" iconName="InterfaceCheck" />
            </SelectedCardContainer>
          )}
        </>
      )}
    </WrapperProduct>
  ) : (
    <WrapperProduct
      $type="1"
      $widgetType={widgetType}
      data-testid="wrapper_product"
    >
      <Unselected item={item} />
    </WrapperProduct>
  );
};

export default ProductCard;
